import React from "react";
import CreatableSelect from "react-select/creatable";
import { ErrorMessage } from "formik";

const FormikCreatableSelect = ({ name, label, value, onChange, options = [], placeholder = "", isClearable = true, isMulti = false,isDisabled = false,}) => {
    
  return (
    <div >
      {label && <label htmlFor={name}>{label}</label>}

      <CreatableSelect
        isClearable={isClearable}
        isMulti={isMulti}
        options={options}
        value={value}
        onChange={(option) => onChange(name, option)}
        placeholder={placeholder}
        isDisabled={isDisabled} 
      />

      {/* <ErrorMessage name={name} component="div" className="text-danger" /> */}
    </div>
  );
};

export default FormikCreatableSelect;
